import { Component, ElementRef, forwardRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  standalone: false,
  selector: 'app-new-time-selector',
  templateUrl: './new-time-selector.component.html',
  styleUrls: ['./new-time-selector.component.scss'],
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> NewTimeSelectorComponent),
      multi: true
    }
  ]
})
export class NewTimeSelectorComponent implements ControlValueAccessor, OnChanges,OnInit {

  @Input() time={hour:0, minute: 0}
  @ViewChild('input') inputRef: ElementRef;
  @Input() onChange?: (time:string)=>void = ()=>{};
  private innerValue = '';
  private startTime:any;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  propagateChanges = (_:any) => {};
  onTouched = ()=>{}

  constructor() { }

  ngOnInit(){
    this.startTime = this.time;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  OnChanges(e:Event, value: any){
    this.innerValue = value;
    if(value.hour!=0){
      this.inputRef.nativeElement.value = value ? this.getAsString(value) : null
    }
    this.propagateChanges(this.innerValue);
  }

  getAsString(value:any):string{
    return  `${('0'+value.hour).slice(-2)}:${('0'+value.minute).slice(-2)}`
  }

  timeChanged():boolean{
    return this.startTime.hour!=this.time.hour || this.startTime.minute!=this.time.minute;
  }

  popOverClose():void{
    if(this.onChange &&  this.timeChanged()){
      this.startTime = this.time;
      this.onChange( this.inputRef.nativeElement.value);
    }
  }
  updateTime = (e:any)=>{
    let value = e.target.value;
    value = value.replace(/\D/g,'');
    if(e.keyCode==8){
      e.target.value ='';
      return;
    }
    if(value.length==2){
      e.target.value = value + ':';
      this.time.hour = value;
    }
    if(value.length>2){
      value = value.substr(0,2) + ':' + value.substr(2);
    }
    if(value.length>5){
      value=value.substr(0,5);
    }
    if(value.length>=4){
      this.time.hour = value.split(':')[0];
      this.time.minute = value.split(':')[1];
    }
    if(this.time.hour>24){
      this.time.hour = 24;
    }
    if(this.time.minute>60){
      this.time.minute = 60;
    }
    e.target.value = value;
    this.time ={hour:Number(this.time.hour), minute: Number(this.time.minute)};
  }

  get value(): any{
    return this.innerValue;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  set value(v: any){
    if(v!=this.innerValue){
      this.innerValue =v;
    }
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  writeValue(value: any): void {
    this.innerValue =value;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  registerOnChange(fn: any): void {
    this.propagateChanges = fn;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  registerOnTouched(fn: any): void {
    this.onTouched =fn;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setDisabledState?(isDisabled: boolean): void {
    throw new Error('Method not implemented.');
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ngOnChanges(changes: SimpleChanges): void {

  }
}
